<script>
import FeedbackHeader from "@/components/feedback/FeedbackHeader.vue";
import ApiService from "@/api/ApiService";
import ObjectGridAdvanced from "@/components/ObjectGridAdvanced.vue";
import FormField from "@/components/feedback/FormField.vue";
import ErrorMessageWrapper from "@/components/ErrorMessageWrapper.vue";

const URL_PUBLIC = "v1/feedback/";
const URL_API = "api/feedback/";
const NEUROBICA = "Neurobica";

export default {
  components: {
    ErrorMessageWrapper,
    FormField,
    ObjectGridAdvanced,
    FeedbackHeader,
  },
  data() {
    return {
      isVisibleModal: false,
      isArchiveFeedback: false,
      feedbackList: [],
      fields: [
        {
          key: "last_name",
          label: "Фамилия",
          required: true,
          cols: 12,
        },
        {
          key: "first_name",
          label: "Имя",
          required: true,
          cols: 12,
        },
        {
          key: "message",
          label: "Отзыв",
          type: "text",
          required: true,
          cols: 12,
        },
        {
          key: "img",
          label: "Изображение",
          type: "img",
        },
        {
          key: "video",
          label: "Видео",
          type: "iframe",
          cols: 12,
        },
        {
          key: "type",
          label: "Тип отзыва",
          type: "radio",
          variants: [
            { value: "Upmind", label: "Upmind" },
            { value: "Neurobica", label: "Neurobica" },
          ],
          cols: 12,
        },
      ],
      selectedFeedback: {},
      isSnackbarVisible: false,
    };
  },
  computed: {
    tableFields() {
      return this.fields
        .filter((item) => item.key !== "avatar")
        .map((field) => {
          return {
            text: field.label,
            value: field.key,
          };
        });
    },
    gridActions() {
      return {
        edit: !this.isArchiveFeedback,
        delete: !this.isArchiveFeedback,
        restore: this.isArchiveFeedback,
      };
    },
  },
  async mounted() {
    await this.getFeedbackList();
  },
  methods: {
    async getFeedbackList() {
      const { data } = await ApiService.get(URL_PUBLIC, { type: NEUROBICA });
      this.feedbackList = data;
    },
    async getFeedbackById(id) {
      const { data } = await ApiService.get(URL_PUBLIC + id);
      this.selectedFeedback = data;
    },
    async openModalFeedback(feedback) {
      this.selectedFeedback = {};
      await this.getFeedbackById(feedback.id);
      this.isVisibleModal = true;
    },
    async saveFeedback() {
      const { data } = await ApiService.put(
        URL_API + this.selectedFeedback.id,
        { ...this.selectedFeedback }
      );
      if (data.error) {
        this.$refs.error_wrapper.showErrorMessage("Ошибка", data.error);
      } else {
        this.isSnackbarVisible = true;
        this.isVisibleModal = false;
      }
    },
  },
};
</script>

<template>
  <div>
    <feedback-header module-name="Neurobica" :value.sync="isArchiveFeedback" />
    <object-grid-advanced
      :value="feedbackList"
      :field-defs="tableFields"
      :show-actions="gridActions"
      title="Отзывы"
      @doEditItem="openModalFeedback"
    />
    <v-dialog v-model="isVisibleModal" max-width="600">
      <form-field
        :value="selectedFeedback"
        :fields="fields"
        @submit="saveFeedback"
      />
    </v-dialog>
    <error-message-wrapper ref="error_wrapper" />
  </div>
</template>

<style scoped lang="scss"></style>
